import { Col, Row, Tooltip } from 'antd';
import React, { ReactElement, ReactNode } from 'react';
import DoctorImage from './../../../shared/components/doctImage/DoctorImage';
import Panel from './../../../shared/components/card/Panel';
import CardActions from './CardActions';
import { authFeatureConstants, GUTTOR_SPACE_SMALL, INVENTORY_MESSAGE_CONSTANTS, INVENTROY_CONSTANTS } from './../../../shared/constants/commonConstants';
import { Qualifications, DoctorDetails } from './../../../shared/models/inventory.model';
import { canActivate, capitalizeFirstLetter, centeredNotification, error, formatPrice, getAgeFromDob } from '../../../utils/utility';
import { fetchDoctorsList } from '../../../store/actions/inventoryAction';
import { useDispatch } from 'react-redux';
import { SaveDoctorDetails } from './SaveDoctors';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';
import { PREFIXES } from '../../../shared/constants/crmConstants';

const DoctorCard = ({ viewDoctorProfile, data, onCollapse, onRefresh }: any): ReactElement => {
  const { personalDetail, professionalDetail, consultationDetail, imageUrl } = data ? data : [] as any;
  const dispatch = useDispatch();

  const onProfileSwitchToggle = async (isActive: boolean): Promise<void> => {
    // const d: DoctorDetails = {
    //   ...data, isActive, personalDetail: {
    //     name: data?.personalDetail?.name,
    //     gender: data?.personalDetail?.gender,
    //     dateOfBirth: data?.personalDetail?.dateOfBirth || new Date(),
    //     imageId: data?.personalDetail?.imageId || '',
    //   },
    // };
    const doctorDetailPayload: DoctorDetails = {
      isActive, id: data?.id, profileId: ApplicationDetail.instance.getProfileId(),
    };
    const response: any = await SaveDoctorDetails(doctorDetailPayload);
    if (response && response?.isSuccess) {
      dispatch(fetchDoctorsList({}));
      centeredNotification(isActive ? INVENTROY_CONSTANTS.profileEnableSuccess : INVENTROY_CONSTANTS.profileDisableSuccess, 'success');
      onRefresh();
    } else if (response && response?.errorMessage) {
      error(response?.errorMessage);
    } else {
      error(INVENTORY_MESSAGE_CONSTANTS.errorOccurred);
    }
  };

  return (
    <>
      <div className="document-card-wraper">
        <Panel className={`doctor-card ${data.isExpanded ? 'primary-border' : ''}`} guttor={GUTTOR_SPACE_SMALL}
          actions={
            [
              <>
                {
                  data &&
                  <CardActions data={data}
                    onCollapse={onCollapse}
                    onRefresh={onRefresh}
                    onProfileSwitchToggle={onProfileSwitchToggle}
                    key={'crdAction'}
                    isDisabled={!canActivate(authFeatureConstants.EDIT_DOCTORS)}
                  />
                }
              </>,
            ]
          }
        >
          <Row gutter={GUTTOR_SPACE_SMALL} onClick={(): any => viewDoctorProfile(data)} className={`${!data.isActive ? 'doc-card-disabled' : ''}`}>
            <Col md={5}>
              <DoctorImage gender={data.personalDetail.gender} imgUrl={imageUrl} status={data.statusName} />
            </Col>
            <Col md={12}>
              <Tooltip title={capitalizeFirstLetter(personalDetail?.name)}>
                <div className="bold text-elipsis">{PREFIXES.DOCTOR}{capitalizeFirstLetter(personalDetail?.name)}</div>
              </Tooltip>
              <div className="bold fsize_sm text-elipsis">{getAgeFromDob(personalDetail?.dateOfBirth) + ' years' + ' | '
                + personalDetail?.gender}</div>
              <div className="doctor-card-qualification">
                {professionalDetail?.qualifications && professionalDetail?.qualifications.map((v: Qualifications, i: number): ReactNode => {
                  return (
                    <React.Fragment key={v.qualificationName + i}>
                      <Tooltip title={v.qualificationName}>
                        <div className="text-elipsis">{v.qualificationName}</div>
                      </Tooltip>
                      {v.additionalQualification &&
                        <Tooltip title={v.additionalQualification}>
                          <div className="text-elipsis">{v.additionalQualification}</div>
                        </Tooltip>
                      }
                    </React.Fragment>
                  );
                })}
              </div>
            </Col>
            <Col md={7} className="text-right" style={{ display: 'flex', flexDirection: 'column' }}>
              <div className="bold text-elipsis">
                {consultationDetail?.consultationFee ? formatPrice(consultationDetail?.consultationFee, false) : ''}
              </div>
              <Tooltip title={professionalDetail?.departmentName}>
                <div className="bold text-elipsis fsize_sm">{professionalDetail?.departmentName}</div>
              </Tooltip>
            </Col>
          </Row>
        </Panel>
      </div>
    </>
  );
};

export default DoctorCard;
